<template>
  <div class="red_packet_statement">
    <div class="feature_col">
      <el-button @click="exportingExcel">导出数据</el-button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      class="table_row"
      height="1"
      ref="table"
      v-loading="loading"
    >
      <el-table-column prop="user_name" label="员工姓名"></el-table-column>
      <el-table-column prop="user_id" label="员工ID"></el-table-column>
      <el-table-column prop="rev_amount" label="领取金额（元）">
        <template slot-scope="scope">{{ scope.row.rev_amount / 100 }}</template>
      </el-table-column>
      <el-table-column label="领取时间时间">
        <template slot-scope="scope">
          {{ scope.row.rev_time | parseTime }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100px">
        <template slot-scope="scope">
          {{ statausData[scope.row.rev_status] }}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination_col">
      <el-pagination
        style="background-color: #ffffff"
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
        :page-size="form.page_size"
        :current-page="form.page_index"
        :page-sizes="g_pageSizesConfig"
        @current-change="currentChange"
        @size-change="sizeChange"
      />
    </div>
  </div>
</template>
<script>
import {
  getRedpackSendDetailListApi,
  exportRedpackSendRecordApi,
} from '@/api/enterpriseWeChatManagement';
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      form: {
        page_size: 10,
        page_index: 1,
        id: this.$route.query.id,
      },
      statausData: {
        0: '未发放',
        1: '发放中',
        2: '已发放待领取',
        3: '发放失败',
        4: '已领取',
        5: '退款中',
        6: '已退款',
      },
      loading: false,
    };
  },
  created() {
    this.form.page_size = this.g_pageSizeDefault;
    this.getRedpackSendDetailList();
  },
  methods: {
    exportingExcel() {
      if (!this.form.id) {
        this.$message.error('没有找到红包id');
        return;
      }
      exportRedpackSendRecordApi({ id: Number(this.form.id) })
        .then((res) => {
          const link = document.createElement('a');
          link.href = res.url;
          link.download = '';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    currentChange(val) {
      this.form.page_index = val;
      this.getRedpackSendDetailList();
    },
    sizeChange(val) {
      this.form.page_index = 1;
      this.form.page_size = val;
      this.getRedpackSendDetailList();
    },
    getRedpackSendDetailList() {
      this.loading = true;
      getRedpackSendDetailListApi(this.form)
        .then((res) => {
          this.loading = false;
          this.total = res.total;
          this.tableData = [];
          this.$nextTick(() => {
            this.tableData = res.info;
          });
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.red_packet_statement {
  height: 100%;
  background: #fff;
  .table_row {
    height: calc(100% - 56px) !important;
  }
  .pagination_col {
    margin-top: 12px;
  }
  .feature_col {
    padding: 24px;
    text-align: right;
  }
}
</style>
